import * as React from "react";
import { SVGProps } from "react";
export function GroupMeetingCallIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#group-meeting-call_svg__a)"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.475 13.542a1.467 1.467 0 1 0 0-2.935 1.467 1.467 0 0 0 0 2.935ZM1.836 17.33c.005-.448.123-.886.343-1.276a2.67 2.67 0 0 1 2.298-1.344 2.67 2.67 0 0 1 2.299 1.344c.22.39.338.828.343 1.276M13.538 13.542a1.468 1.468 0 1 0 0-2.935 1.468 1.468 0 0 0 0 2.935ZM10.89 17.33c.005-.448.123-.886.344-1.276a2.67 2.67 0 0 1 2.298-1.344 2.67 2.67 0 0 1 2.299 1.344c.22.39.338.828.343 1.276M9.003 5.203a1.37 1.37 0 1 0 0-2.74 1.37 1.37 0 0 0 0 2.74ZM6.445 8.638c.005-.434.12-.86.333-1.237a2.589 2.589 0 0 1 2.228-1.303 2.589 2.589 0 0 1 2.23 1.303c.213.378.327.803.332 1.237" />
        <path d="M15.15.7H2.852a.923.923 0 0 0-.923.924v6.09c0 .51.413.924.923.924H15.15c.51 0 .924-.414.924-.924v-6.09a.923.923 0 0 0-.924-.923Z" />
      </g>
      <defs>
        <clipPath id="group-meeting-call_svg__a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
